<template>
  <div class="bg">
    <div class="top">
      <div class="text">
        <div class="title">
          建模与分析
        </div>
        <div class="value">
          浩顿的建模和分析服务可帮助您管理大量未经过滤的数据集，从而提供直接而敏锐的业务见解。数据集可以来自结构良好的研究项目，也可以来自日常操作数据。

        </div>
        <div><button @click="contact">联系我们</button></div>
      </div>
    </div>

    <!-- 中间文字 -->
    <div class="data">
      <div class="img"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/modeling/data.jpg"></div>
      <div class="text">我们的数据工程师和统计人员也可以在您的研究开始时推荐合适的研究模型。通过利用我们的<span @click="toguid('/toolbox?source=webtable','SurveyPanda');btn('/toolbox?source=webtable','SurveyPanda')" style="color:#159445;cursor:pointer">调查熊猫</span>和建模平台，您可以为您的业务问题构建高度优化和有效的解决方案。

        一些内置模型包括MaxDiff, Turf，联合分析，PSM和KANO模型。

      </div>
    </div>

    <!-- 下面的表格 -->
    <div class="table">

      <el-dropdown>
        <span class="el-dropdown-link">
          回归分析
        </span>
        <el-dropdown-menu slot="dropdown">
          <div class="value">有助于显示两个变量之间的相关性(或缺乏相关性)。您可以确定一组数据是否依赖于另一组数据的因果关系。
          </div>
        </el-dropdown-menu>
      </el-dropdown>

      <el-dropdown>
        <span class="el-dropdown-link">
          相关分析
        </span>
        <el-dropdown-menu slot="dropdown" class="value">
          <div class="value">用于度量两个变量之间的线性关系的强度，并计算它们之间的关联。</div>
        </el-dropdown-menu>
      </el-dropdown>

      <el-dropdown>
        <span class="el-dropdown-link">
          因子分析
        </span>
        <el-dropdown-menu slot="dropdown">
          <div class="value">对多组数据执行数据降维。

            因子分析是将许多变量压缩成几个变量的实践，这样你的研究数据就更容易处理。
          </div>
        </el-dropdown-menu>
      </el-dropdown>

      <el-dropdown>
        <span class="el-dropdown-link">
          聚类分析
        </span>
        <el-dropdown-menu slot="dropdown">
          <div class="value">一种多变量数据挖掘技术，其目标是根据一组用户选择的特征或属性将对象(如客户、实体、产品)分组为类。
          </div>
        </el-dropdown-menu>
      </el-dropdown>

      <el-dropdown>
        <span class="el-dropdown-link">
          对应分析
        </span>
        <el-dropdown-menu slot="dropdown">
          <div class="value">一种有用的数据科学可视化技术，用于发现和显示类别之间的关系。它使用图形来绘制数据，直观地显示两个或多个数据点的结果。它经常用于品牌定位研究。
          </div>
        </el-dropdown-menu>
      </el-dropdown>

      <el-dropdown>
        <span class="el-dropdown-link">
          结构方程模型
        </span>
        <el-dropdown-menu slot="dropdown">
          <div class="value">经常被市场营销和商业专业人士用于评估经验性的新理论建议。它用于检验和评估多变量因果关系。
          </div>
        </el-dropdown-menu>
      </el-dropdown>

    </div>

    <!-- 尾部 -->
    <div class="talk">
      <div class="value">与我们的数据工程师和定量研究专家交谈 </div>
      <button @click="contact">联系我们</button>
    </div>
  </div>
</template>

<script>
import { advertisementFlow } from "@/api/api";

export default {
  data() {
    return {};
  },
  created() {
    this.loading();
    this.advertisementFlow(); // 在组件创建时加载Google代码
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://www.googletagmanager.com/gtag/js?id=AW-11335422054";
    document.head.appendChild(script);
    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        dataLayer.push(arguments);
      }
      gtag("js", new Date());
      gtag("config", "AW-11335422054");
    };
    this.webinercookies();
  },
  methods: {
    btn(path, id) {
      // 跳转页面
      this.$router.push({
        path
      });
      this.isShow = false;
      if (id) {
        document.getElementById(id).scrollIntoView({ behavior: "smooth" });
      }
      // console.log(index);
    },
    toguid(path, id) {
      var Id = id;
      localStorage.setItem("toId", Id);
      this.$router.push({ path });
    },
    webinercookies() {
      // 如果没有记录cookie
      if (!localStorage.getItem("webinersource")) {
        // 就不重新赋值
        let webinersource = this.$route.query.source;

        if (webinersource == undefined) {
          localStorage.setItem("webinersource", "www");
        } else {
          localStorage.setItem("webinersource", webinersource);
        }
        // console.log(1);
      } else {
        // 如果没有cookie就设置cookie
      }
    },
    advertisementFlow() {
      // 如果没有source
      if (this.$route.query.source == undefined) {
        // console.log(1);
        // 就把source拼接
        advertisementFlow({
          path: "modeling",
          source: "",
          information: "Solutions_modeling"
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
          }
        });
        // 如果有source
      } else {
        advertisementFlow({
          path: "modeling",
          source: this.$route.query.source,
          information: "Solutions_modeling"
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
          }
        });
      }
    },
    contact() {
      let routeData = this.$router.resolve({ path: "/cn/contact?source=bid" });
      window.open(routeData.href, "_blank");
    },
    loading() {
      this.$loading({
        lock: true,
        background: "rgba(255, 255, 255,1)"
      });
      setTimeout(() => {
        this.$loading().close();
      }, 700);
    }
  }
};
</script>

<style lang="scss" scoped>
.bg {
  background-image: url("https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/modeling/bg1.jpg");
  background-attachment: fixed;
  background-size: cover;
}
.top {
  background-color: #fff;
  padding: 115px 200px;
  // height: 600px;
  background-image: url("https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/modeling/modelingbg.png");
  background-size: cover;
  .text {
    color: #fff;
    width: 60%;
    .title {
      width: 70%;
      font-size: 50px;
      font-weight: 700;
      margin-bottom: 25px;
    }
    .value {
      font-size: 20px;
    }
    button {
      border: none;
      background-color: #2cb1e9;
      color: #fff;
      font-size: 20px;
      border-radius: 10px;
      margin-top: 20px;
      padding: 10px;
    }
  }
}
.data {
  background-color: #fff;
  display: flex;
  flex-wrap: wrap;
  padding: 80px 120px;
  .img {
    width: 45%;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .text {
    background-color: #2cb1e9;
    padding: 50px;
    width: 55%;
    font-size: 23px;
    color: #fff;
  }
}
.table {
  background-color: rgba(255, 255, 255, 0.5);
  padding: 80px 120px 0 120px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 0;
}
.talk {
  background-color: #2cb1e9;
  display: flex;
  justify-content: space-between;
  padding: 50px 120px;
  font-size: 30px;
  font-weight: 700;
  color: #fff;
  button {
    background-color: #4f81bd;
    border: none;
    font-size: 23px;
    border-radius: 10px;
    padding: 10px;
  }
}
@media screen and (max-width: 576px) {
  .top {
    padding: 80px 100px;
    .text {
      width: 100%;
      .title {
        width: 80%;
        font-size: 110px;
      }
      .value {
        font-size: 70px;
      }
      button {
        font-size: 70px;
        padding: 10px 20px;
      }
    }
  }
  .data {
    display: block;
    .img {
      width: 100%;
    }
    .text {
      width: 100%;
      font-size: 70px;
    }
  }
}
</style>
<style lang="scss">
.el-dropdown {
  width: 30%;
  text-align: center;
  background-color: #2cb1e9;

  margin-bottom: 80px;
  .el-dropdown-link {
    display: flex;
    align-items: center;
    justify-content: center;
    // display: inline-block;
    padding: 10px;
    text-align: center;
    height: 150px;
    // background-color: #2cb1e9;
    font-size: 40px;
    font-weight: 700;
    color: #fff;
  }
}
.el-dropdown-menu {
  width: 550px;
  font-size: 23px;
  background-color: #d0e3ea;
  padding: 10px;
}
@media screen and (max-width: 576px) {
  .el-dropdown {
    width: 100%;
    .el-dropdown-link {
      font-size: 80px;
      height: 300px;
      padding: 20px;
      width: 100%;
    }
  }
  .el-dropdown-menu {
    width: 90%;
    font-size: 70px;
    padding: 20px;
  }
}
</style>